import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';

import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ProgramStatusSummaryReportQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/queries/tableDataQuery';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { KeyAchievementsTableComponent } from 'components/widgets/KeyAchievements/keyAchievementsTableComponent';
import KeyActivitiesWidget from 'components/widgets/KeyActivities/KeyActivities';
import PrioritiesMatrixComponent from 'components/widgets/PrioritiesMatrix/prioritiesMatrixComponent';
import ScoreCardsComponent from 'components/widgets/ProjectSummary/scoreCardsComponent';
import SummaryTrackedActivitiesComponent from 'components/widgets/SummaryTrackedActivities/summaryTrackedActivitiesComponent';

export const ProjectStatusPage = () => {
    useFullStoryPageView({ pageName: projectConfig.statusSummary.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return ProgramStatusSummaryReportQueryKeys.includes(key);
        },
    });
    useScrollTo(isFetching);

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={projectConfig.statusSummary.title} />
                        <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                    </VersionSection>

                    <GlobalFilterButton />
                </VersionWrapper>
                <GlobalFilterComponent
                    defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                >
                    <MilestoneFragnetFilter name={'milestoneFragnet'} />
                    <TagsFilter name={'tags'} />
                    <ActivityCodesFilter name={'activityCodes'} />
                    <WbsFilter name={'wbs'} />
                </GlobalFilterComponent>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ScoreCardsComponent />
                    <PrioritiesMatrixComponent />
                    <KeyAchievementsTableComponent />
                    <KeyActivitiesWidget />
                    <SummaryTrackedActivitiesComponent />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={ProgramStatusSummaryReportQueryKeys} />
        </PageContainer>
    );
};
